const getCasinoReducer = state => state.casino;

export default {
  isSIC: store => getCasinoReducer(store).isSIC,
  gamblingSession: store => getCasinoReducer(store).gamblingSession
};
